// Anything exported from this file is importable by other in-browser modules (Micro APP).
import { BehaviorSubject } from "rxjs";

/** @description Below Observable to save selected plant  */
let plantSubject = new BehaviorSubject({});

/** @description Below Observable to save plant list */
let plantListSubject = new BehaviorSubject([]);

/** @description used for user subscription */
let userProfileSub = new BehaviorSubject([]);

/** @description used for Event redirection from site locator widgets*/
let plantChangedFromSite = new BehaviorSubject([]);

let subscriptionDataSubject = new BehaviorSubject([]);

export function getSubscriptionDetails() {
  return subscriptionDataSubject;
}

export function setSubscriptionDetails(subdetails) {
  subscriptionDataSubject.next(subdetails);
}

let authFlag = new BehaviorSubject([]);

export function getSelectedPlant() {
  return plantSubject;
}

export function setIsPlantChanged(plantDetails) {
  plantSubject.next(plantDetails);
}

export function getPlantList() {
  return plantListSubject;
}

export function setPlantList(response) {
  plantListSubject.next(response);
}

export function getplantChangedFromSiteLocator() {
  return plantChangedFromSite;
}

export function setplantChangedFromSiteLocator(response) {
  plantChangedFromSite.next(response);
}

/**
 * @description selected plant details setting in state.
 */
export function setUserObject(userProfile) {
  userProfileSub.next(userProfile);
}

/**
 * @description get plant details setting in state.
 */
export function getUserProfileObj() {
  return userProfileSub;
}

export function setAccessToken() {
  var values = [],
    keys = Object.keys(localStorage),
    i = keys.length;
    let authorityKey = [];
    for ( var i = 0, len = localStorage.length; i < len; ++i ) {
      if (localStorage.getItem(localStorage.key( i )).includes("accessToken") &&
      !(localStorage.getItem(localStorage.key( i )).includes("authority"))) {
        authorityKey.push(localStorage.getItem(localStorage.key( i )));
      }
      // console.log( localStorage.key( i ) + ": " + localStorage.getItem( localStorage.key( i ) ) );
    }
  
  // keys.forEach((key, index) => {
  // });

  // while (i--) {
  //     values.push(localStorage.getItem(keys[i]));
  // }
  if (authorityKey[0]) {
    let authorityKeyParsedObject = JSON.parse(authorityKey[0]);
    if (authorityKey[1]) {
      let authorityKeyParsedObjectOne = JSON.parse(authorityKey[1]);
      if (
        authorityKeyParsedObjectOne.expiresIn >
        authorityKeyParsedObject.expiresIn
      ) {
        localStorage.setItem(
          "accessToken",
          authorityKeyParsedObjectOne.accessToken
        );
      } else {
        localStorage.setItem(
          "accessToken",
          authorityKeyParsedObject.accessToken
        );
      }
    }
  }
}

export function getAccessToken() {
  return localStorage.getItem("accessToken");
}

/**
 *
 *
 * @export
 * @param {*} flag
 * @description get authentication flag
 */
export function setAuthFlag(flag) {
  authFlag.next(flag);
}
export function getAuthFlag() {
  return authFlag;
}
